import { toast } from 'react-toastify';
import { apiClient } from './client';
import { handleApiError } from './utils';

export const uploadFile = async ({
    apiEndpoint,
    fileName,
    fileTypeId,
    file,
    reference = null,
    callFormReference = null
}) => {
    if (!apiEndpoint) {
        toast.error("Dosya yüklemek için API endpoint'i gereklidir.");
        throw new Error('API endpoint is missing for file upload.');
    }

    if (!fileName) {
        toast.error('Dosya yüklemek için dosya adı gereklidir.');
        throw new Error('File name is missing for file upload.');
    }

    if (!fileTypeId) {
        toast.error('Dosya yüklemek için dosya türü gereklidir.');
        throw new Error('File type ID is missing for file upload.');
    }

    if (!file) {
        toast.error('Yüklenecek dosya seçilmedi.');
        throw new Error('File is missing for file upload.');
    }

    if (!reference && !callFormReference) {
        toast.error('Referans bilgisi gereklidir.');
        throw new Error('Either reference or callFormReference is missing for file upload.');
    }

    try {
        const formData = new FormData();

        formData.append('Type', fileTypeId);

        if (callFormReference) {
            formData.append('CallFormReference', callFormReference);
        }

        if (reference) {
            formData.append('Reference', reference);
        }

        formData.append('file', file, fileName);

        const response = await apiClient.post(apiEndpoint, formData);

        if (response.status >= 200 && response.status < 300) {
            return response.data;
        } else {
            throw new Error(`Unexpected response status: ${response.status}`);
        }

    } catch (error) {
        handleApiError(error, 'Dosya yüklenirken bir hata oluştu.');
        throw error;
    }
};

export const deleteFile = async (fileId) => {
    try {
        const response = await apiClient.delete(`/UploadedFile/${fileId}`);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Dosya silinirken bir hata oluştu.');
        throw error;
    }
};
